var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('miembro-table',{attrs:{"controller":"MiembroSiuben","title":_vm.titulo,"codigo-hogar":_vm.codigoHogar,"hogar-id":_vm.hogarId,"excluidos":false},on:{"config":_vm.onLoadTable}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }